// extracted by mini-css-extract-plugin
export var active = "styles-module__active___sTfct";
export var buttonContainer = "styles-module__buttonContainer___Ey_4x";
export var container = "styles-module__container___jehPm";
export var dot = "styles-module__dot___r7JZm";
export var dotContainer = "styles-module__dotContainer___D60fW";
export var header = "styles-module__header___duQLN";
export var mobileSliderContainer = "styles-module__mobileSliderContainer___XfbhZ";
export var sliderContainer = "styles-module__sliderContainer___If9wc";